
import { mapState } from 'vuex'
import _ from 'lodash'
import SimpleSearchProductElement from '../../components/product/single'
import PaginationCommon from '../../components/element-ui/Pagination'
import ExpandContact from '../../components/contact/ExpandContact.vue'

import {
  SET_REMOVE_FILTER,
  SET_CLEAR_ALL_FILTER,
  SHOP_GET_DETAIL,
  SHOP_GET_LIST_CATEGORY,
  SHOP_GET_LIST_PRODUCT,
  INDEX_SET_LOADING,
  INDEX_SET_SUCCESS,
  INDEX_SET_ERROR,
  AUTH_OPEN_MODAL_LOGIN,
  SHOP_FOLLOW_SHOP,
  CHAT_SET_CHAT_WITH_SHOP, INDEX_SET_HIDE_FOOTER
} from '../../store/store.const'
import FilterBasic from '../../components/element-ui/filter/FilterBasic'

export default {
  name: 'ShopDetail',
  components: { FilterBasic, PaginationCommon, SimpleSearchProductElement, ExpandContact },
  layout: 'default-details',
  data() {
    const PRODUCT_DEFAULT = []
    const FOLLOW = 1
    const UN_FOLLOW = 2
    return {
      slug: this.$route.params.slug,
      id: null,
      listCategory: [],
      isShowPhone: false,
      products: _.cloneDeep(PRODUCT_DEFAULT),
      productDefault: PRODUCT_DEFAULT,
      listFilter: [
        'category_search',
        'price',
        'price_range',
        'branch',
        'rating',
        'promo'
      ],
      total: 0,
      page: 1,
      last_page: 1,
      per_page: 24,
      type_sort: 6,
      list_sort: [
        {
          text: 'popular',
          value: 6,
          label: this.$t('sort.popular')
        },
        {
          text: 'new',
          value: 1,
          label: this.$t('sort.new')
        },
        {
          text: 'hot_sale',
          value: 2,
          label: this.$t('sort.hot_sale')
        },
        {
          text: 'sort_desc',
          value: 3,
          label: this.$t('sort.sort_desc')
        },
        {
          text: 'sort_asc',
          value: 4,
          label: this.$t('sort.sort_asc')
        }
      ],
      dataFilter: [],
      follow: FOLLOW,
      un_follow: UN_FOLLOW,
      storeDetail: {
        id: null,
        avatar: '',
        name: '',
        follower: 0,
        percentFeedback: 0,
        products: 0,
        createdAt: '',
        rate: 0,
        totalRate: 0,
        description: '',
        address: ''
      },
      listSelect: {
        shop_category_id: {
          status: true,
          value: []
        }
      },
      nextPage: true
    }
  },
  computed: {
    ...mapState('filter', {
      clearAllFilter: state => state.clearAllFilter,
      addFilter: state => state.addFilter
    }),
    ...mapState('authentication', {
      openModalLoginState: state => state.openModalLoginState
    }),
    hideFooter() {
      return this.$store.state.hideFooter
    }
  },
  watch: {
    async type_sort() {
      await this.getListProduct()
    }
  },
  async created() {
    await this.fetchData()
    await this.getListProduct()
  },
  mounted() {
    window.onscroll = async() => {
      const bottomOfWindow = document.documentElement.offsetHeight - (document.documentElement.scrollTop + window.innerHeight) < 100
      if (bottomOfWindow && this.hideFooter && this.$device.isMobile && this.nextPage) {
        this.nextPage = false
        this.page++
        await this.getListProduct()
        this.nextPage = true
      }
    }
  },
  methods: {
    async chatWithShop() {
      if (this.$auth.loggedIn) {
        await this.$store.commit(CHAT_SET_CHAT_WITH_SHOP, this.storeDetail)
      } else {
        await this.$store.commit(AUTH_OPEN_MODAL_LOGIN, !this.openModalLoginState)
      }
    },

    async changeDataFilter(value) {
      const data = []
      let check = true
      this.dataFilter.forEach(filter => {
        if (filter.type === value.type) {
          if (value.value.length > 0) {
            data.push(value)
          }
          check = false
        } else {
          data.push(filter)
        }
      })
      if (check) data.push(value)
      this.dataFilter = data
      await this.getListProduct()
    },
    removeFilter(type, data) {
      this.$store.commit(SET_REMOVE_FILTER, { type, value: data })
    },
    clearFilter() {
      this.$store.commit(SET_CLEAR_ALL_FILTER, !this.clearAllFilter)
    },
    changeToLink(link) {
      this.$router.push(link)
    },
    async fetchData() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const dataSlug = this.$route.params.slug
        const shop = await this.$store.dispatch(SHOP_GET_DETAIL, dataSlug)
        this.id = shop.data.id
        const categories = await this.$store.dispatch(SHOP_GET_LIST_CATEGORY, shop.data.id)
        this.listCategory = categories.data.map(category => {
          return { ...category, value: category.name }
        })
        this.storeDetail = shop.data
        document.title = this.storeDetail.name + ' - ' + this.$t('home.title')
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    async changePaginate(page) {
      this.page = page
      await this.getListProduct()
    },
    async getListProduct() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const search = {
          page: this.page,
          per_page: this.per_page
        }
        this.dataFilter.forEach(data => {
          search[data.type] = data.list.join(',')
        })
        if (this.type_sort) {
          search.order_by = this.type_sort
        }
        const products = await this.$store.dispatch(SHOP_GET_LIST_PRODUCT, { id: this.id, filters: search })
        if (!this.$device.isMobile) {
          this.products = products.data.data
          this.page = products.data.current_page
          this.last_page = products.data.total_page
          this.total = products.data.total
        } else {
          this.products = this.products.concat(products.data.data)
          this.page = products.data.data.length ? products.data.current_page : (this.page - 1)
          this.last_page = products.data.total_page
          this.total = products.data.total
          this.$store.commit(INDEX_SET_HIDE_FOOTER, products.data.data.length > 0)
        }
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    updateFilter(dataFilter) {
      if (this.listSelect[dataFilter.type] === undefined) {
        dataFilter.status = true
      } else {
        dataFilter.status = this.listSelect[dataFilter.type].status
      }
      this.listSelect[dataFilter.type] = dataFilter
      this.changeDataFilter(dataFilter)
    },
    async followShow(status) {
      if (!this.$auth.loggedIn) {
        await this.$store.commit(AUTH_OPEN_MODAL_LOGIN, !this.openModalLoginState)
        return
      }
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const data = await this.$store.dispatch(SHOP_FOLLOW_SHOP, { id: this.id, body: { status }})
        if (data.status_code === 200) {
          this.storeDetail.follow_state = (status === this.follow)
          await this.fetchData()
          await this.$store.commit(INDEX_SET_SUCCESS, { show: true, text: data.message })
        } else {
          await this.$store.commit(INDEX_SET_ERROR, { show: true, text: data.message })
        }
      } catch (err) {
        await this.$store.commit(INDEX_SET_ERROR, { show: true, text: this.$t('message.message_error') })
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    }
  }
}
